var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { O } from "vwebapp-framework";
import { MapUIStore as MapUIState } from "./write/map";
export class WriteState {
    constructor() {
        this.targetWeekCompletion = 1;
        this.map = new MapUIState();
        this.events_panelsVisible = ["characters", "unordered", "ordered", "event details"];
        this.events_actionGridVisible = true;
        this.events_textVisible = true;
    }
}
__decorate([
    O
], WriteState.prototype, "subpage", void 0);
__decorate([
    O
], WriteState.prototype, "targetWeekCompletion", void 0);
__decorate([
    O
], WriteState.prototype, "showAllSeeds", void 0);
__decorate([
    O
], WriteState.prototype, "selectedBook", void 0);
__decorate([
    O
], WriteState.prototype, "selectedCharacter", void 0);
__decorate([
    O
], WriteState.prototype, "selectedSeed", void 0);
__decorate([
    O
], WriteState.prototype, "selectedEvent", void 0);
__decorate([
    O
], WriteState.prototype, "selectedEvent_character", void 0);
__decorate([
    O
], WriteState.prototype, "selectedEvent_position", void 0);
__decorate([
    O
], WriteState.prototype, "seeds_eventCountWeight", void 0);
__decorate([
    O
], WriteState.prototype, "characters_showAttributes", void 0);
__decorate([
    O
], WriteState.prototype, "characters_showDescription", void 0);
__decorate([
    O
], WriteState.prototype, "screenshotMode", void 0);
__decorate([
    O
], WriteState.prototype, "map", void 0);
__decorate([
    O
], WriteState.prototype, "selectedTool", void 0);
__decorate([
    O
], WriteState.prototype, "tools", void 0);
__decorate([
    O
], WriteState.prototype, "selectedObject", void 0);
__decorate([
    O
], WriteState.prototype, "events_panelsVisible", void 0);
__decorate([
    O
], WriteState.prototype, "events_actionGridVisible", void 0);
__decorate([
    O
], WriteState.prototype, "events_textVisible", void 0);
